import slidesPreloader from '../../utils/SlidesPreloaderNew';
import audioEditorUtils from './AudioEditorUtils';
import uuid from 'uuid';
import playController from '../../utils/PlayController';

const audioConverter = {
    addSoundDurationToMap(audioHref, duration) {
        if (playController.isAudioEditorAvailable())
            return;

        var durationMap = slidesPreloader.audioDurationMap;

        if (durationMap[audioHref] > 0)
            return;
        else {
            durationMap[audioHref] = duration;
        }
    },
    getSound(slide, isEffect = true) {
        var href;
        var title;
        var hrefBlob;

        if (isEffect) {
            href = slide.soundEffect;
            title = slide.soundEffectTitle;
        } else {
            if (slide.soundWav && slide.soundWav.length > 0)
                hrefBlob = slide.soundWav;

            href = slide.sound;
            title = slide.soundTitle;
        }

        if ((href != undefined && href.length > 0) || (hrefBlob != undefined && hrefBlob.length > 0))
            return {href, title, hrefBlob};
        else
            return undefined;
    },
    getAudioItem(slide, currentPosition, isEffect = true) {
        var sound = this.getSound(slide, isEffect);

        if (sound == undefined)
            return undefined;

        var durationMap = slidesPreloader.audioDurationMap;
        var realDuration = -1;

        if (durationMap && durationMap[sound.href] > 0)
            realDuration = durationMap[sound.href];

        var slideDuration = slide.time;
        var item = {};

        item.title = sound.title;
        item.href = sound.href;
        item.uuid = uuid.v4();
        item.left = currentPosition;
        item.inPoint = 0;

        if (sound.hrefBlob)
            item.hrefBlob = sound.hrefBlob;

        audioEditorUtils.ensureHasContentItem(item);

        if (realDuration > 0) {
            if (realDuration < slideDuration)
                item.duration = realDuration;
            else {
                if (realDuration > slideDuration)
                    item.outPoint = realDuration - slideDuration;

                item.duration = slideDuration;
            }
        } else
            item.duration = slideDuration;

        return item;
    },
    getStorySound(totalDuration, storySound) {
        if (storySound && storySound.href && storySound.href.length > 0) {
            var item = {};
            var durationMap = slidesPreloader.audioDurationMap;
            var realDuration = -1;

            if (durationMap && durationMap[storySound.href] > 0)
                realDuration = durationMap[storySound.href];

            item.title = storySound.title;
            item.href = storySound.href;
            item.uuid = uuid.v4();
            item.left = 0;
            item.inPoint = 0;
            audioEditorUtils.ensureHasContentItem(item);

            if (realDuration > 0) {
                if (realDuration < totalDuration)
                    item.duration = realDuration;
                else {
                    if (realDuration > totalDuration)
                        item.outPoint = realDuration - totalDuration;

                    item.duration = totalDuration;
                }
            } else
                item.duration = totalDuration;

            return item;
        } else
            return undefined;
    },
    convert(slides, storySound) {
        var i;
        var audioEditor = {};
        var timelines = [];
        var recordingTimeline = {index: 0, volume: 1, audios: []};
        var effectsTimeline = {index: 1, volume: 1, audios: []};
        var currentPosition = 0;
        var audioItem;
        var item;

        for (i=0; i<slides.length; i++) {
            var slide = slides[i];

            // add recorded sound
            audioItem = this.getAudioItem(slide, currentPosition, false);

            if (audioItem)
                recordingTimeline.audios.push(audioItem);

            // add effect sound
            audioItem = this.getAudioItem(slide, currentPosition, true);

            if (audioItem)
                effectsTimeline.audios.push(audioItem);

            currentPosition = currentPosition + slide.time;
        }

        timelines.push(recordingTimeline);
        timelines.push(effectsTimeline);

        // add story sound
        var storySoundItem = this.getStorySound(currentPosition, storySound);
        item = {index: 2, volume: 1, audios: []};

        if (storySound) {
            item.audios.push(storySoundItem);
        }

        timelines.push(item);

        audioEditor.markerPosition = -1;
        audioEditor.zoomValue = 4;
        audioEditor.timelines = timelines;
        audioEditor.isOldProduction = true;

        return audioEditor;
    }
};

export default audioConverter;



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/utils/AudioConverter.js
 **/